import { render, staticRenderFns } from "./ReleaseNotesPage.vue?vue&type=template&id=0be841d4&"
import script from "./ReleaseNotesPage.vue?vue&type=script&lang=ts&"
export * from "./ReleaseNotesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports